// extracted by mini-css-extract-plugin
export default {"hajjSeasonNotice":"Qoc9rxKCyCfD6E9K6FC0"};